import React from "react";
const Substract = ({ height = "24", width = "24" }) => (React.createElement("svg", { height: height, width: width, fill: "none", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { d: "M6 11C5.44772 11 5 11.4477 5 12C5 12.5523 5.44772 13 6 13H18C18.5523 13 19 12.5523 19 12C19 11.4477 18.5523 11 18 11H6Z", fill: "#0E1D31" })));
export default Substract;
